/*
 * @Author: your name
 * @Date: 2021-01-12 19:40:31
 * @LastEditTime: 2021-07-22 19:20:46
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-shop/src/utils/srcoll.js
 */

function _srcollToErrorDom(className) {
  this.$nextTick(_ => {
    const errDom = document.querySelector(`.${className}`)
    if (errDom) {
      errDom.scrollIntoView({
        block: 'center',
        behavior: 'smooth',
      })
    }
  })
}

export {
  _srcollToErrorDom
}
